import { FC, memo, useCallback, useEffect, useMemo, useState, lazy } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Colors, FlexBox, Skeleton } from '@brg/ui';
import { API, Competition, CompetitionAPI, PageModel, Project, Tag, Team } from '@brg/api';
import ReactTooltip from 'react-tooltip';
import styled, { ThemeProvider, css, createGlobalStyle } from 'styled-components';
import StickyActionBar from 'shared/components/stickyActionBar';
import ProjectDisplayLayout, { VoteLongreadBlockWrapper } from '../../components/template/project-display-layout';
import { getProjectImages, PSImage } from './sections/ps-image';
import { PSAuthor } from './sections/ps-author';
import { PSBottom, VOTE_BLOCK_POSITION } from './sections/ps-bottom';
import { PSTeam } from './sections/ps-team';
import { PSLongread } from './sections/ps-longread';
import { PSMoreTitle } from './sections/ps-more-title';
import { PageViewportLayout } from '../../components/template/page-template';
import { RoomLaunchBlockView } from '../projectEdit/components/RoomLaunchBlock';
import { CreateLinkTo } from '../../constants/linkTo';
import { bTag, LayoutConst, useModal, useZoom } from '../../../core';
import { BTag } from '../../../core/components';
import PsOtherProjects from './sections/ps-other-projects';
import { AGEYTOMESH_TAG_ID } from "../../constants/misc";
import { ScrollUpZone } from "../../components/__FOX__/NAV/src/scroll-up-zone";
import { useLongreadCounts } from 'shared/hooks/useLongreadCounts';
import { LongreadCountViewer } from 'shared/components/__FOX__/NAV/src/longread-count-viewer';
import { ChaptersNavigation, Position } from '_deziiign/books/core/components/chaptersNavigation/ChaptersNavigation';
import { TagStatusDeleted } from 'shared/helpers/tagStatus';
import { InPartCompetition } from './components/InPartCompetition';
import { createPortal } from 'react-dom';
import { ProjectStatus } from './components/ProjectStatus';
import { PSBottomActions } from './sections/ps-bottom-actions';
import ApprovalDialog from './components/ApprovalDialog';
import { PSChapters } from '_deziiign/books/pages/sections/ps-chapters';
import { ProjectPoint } from './components/ProjectPoint';
import OrganizationApprovalDialog from "./components/OrganizationApprovalDialog";
import { ProjectPurchase } from './components/ProjectPurchase';
import { ProjectContextName } from './components/ProjectContextName';
import { ProtectStatus } from './sections/ps-protect-status';
import { BookmarkButtonProjectPage } from 'shared/components/bookmarkButtonOnProject/BookmarkButtonProjectPage';
import { CustomBgWrapper } from "../../components/CustomBgWrapper/CustomBgWrapper";
import { ProjectDelegate } from 'project-delegate';
import { CommonProjectContainer, ProjectLongreadWrapper, PsnTitle } from './styles';
import { PSpresentationBlock } from './sections/ps-presentation-block';
import { PsPresentationBtns } from './sections/ps-presentation-btns';
import { SP_VOTE_COLLECTION_SIGN } from '../VotesAdmin/VotesAdminPage';
import { VoteCollectionCover } from '../projectEdit/components/VoteCollectionCover/VoteCollectionCover';
import { useGetPollByParentEntity } from "../../hooks/api/useGetPollByParentEntity";
import { ProjectGameInfo } from "./components/ProjectGameInfo";
import { GameStatuses } from "../../constants/GameStatuses";
import { PSShop } from "./sections/ps-shop";
import { ModerationType } from "../teams/const/ModerationTypes";
import LMSLongreadList from "./components/LMSLongreadList";
import { getTooltipStyles, tooptipStylesWhite } from 'shared/constants/tooptipStyles';
import { WarholCardCover, WarholCardCoverBg } from "../../components/WarholCardCover/WarholCardCover";
import { BookCardsWithPay } from "../../../_deziiign/books/pages/BookEdit/components/BookCards/BookCards";
import { QueueMode, QueueNew } from "../../features/QueuePaymenrt/components/Queue/New/QueueNew";
import {
    QueueCircleType,
    QueueRate
} from "../../features/QueuePaymenrt/components/Queue/New/components/QueueLineNew/QueueLineNew";
import { PaymentStatus } from "../../../_deziiign/books/pages/BookEdit/BookEdit";
import { QueueButtons } from "./components/QueueButtons";
import { LongreadShopButtons } from "../../components/LongreadShopButtons";
import VoteBlock from './components/VoteBlock/VoteBlock';
import { InPartExam } from "./components/InPartExam";
import { PsProtectInfo } from './sections/ps-protect-info';
import { SubscribeInfo } from './components/SubscribeInfo';
import { getDisciplineColorFromId } from "../../helpers/LMS/getDisciplineColorFromId";
import tinycolor from 'tinycolor2';
import { BookBuyProcessingComponent } from "./components/BookBuyProcessingComponent";
import { TagsEditor } from "./components/TagsEditor";
import { ITeamEntity } from "../../hooks/useGetCurrentTeam";
import { isServer } from "../../constants/isServer";
import { AppTester } from 'supporting';
import { STATUSES } from '_competition/const';
import { CompetitionProjectsActions, CompetitionProjectsSelector } from 'shared/reducers/CompetitionProjects';
import { useDispatch, useSelector } from 'react-redux';
import { selectorLMSModuleInfo } from 'shared/reducers/LMSSlice';
import { StudentProjectBlock } from './components/StudentProjectBlock';
import ModerationContext from 'shared/contexts/ModerationContext';

const ChildrensBookView = lazy(() => import('../ChildrensBooks/BookView/ChildrensBookView'));

const MetaTags = isServer
    ? FlexBox
    : lazy(() => import("../../components/MetaTags"))

import { clearTrackInfo } from 'shared/components/AudioPlayer/reducers/AudioSlice';

export const sortTags = (tags: Tag[]) => {
    //@ts-ignore
    const { educational, rest } = tags.reduce((res, tag) => {
        //@ts-ignore
        if (tag?.isEducationTag) {
            return {
                ...res,
                educational: [...res.educational, tag],
            }
        }
        return {
            ...res,
            rest: [...res.rest, tag],
        }
    }, {
        educational: [],
        rest: [],
    });
    //@ts-ignore
    const { cities, notCities } = rest.reduce((res, tag) => {
        if (tag?.entityTypes?.includes('cities')) {
            return {
                ...res,
                cities: [...res.cities, tag],
            }
        }
        return {
            ...res,
            notCities: [...res.notCities, tag],
        }
    }, {
        cities: [],
        notCities: [],
    });
    //@ts-ignore
    const { places, notPlaces } = notCities.reduce((res, tag) => {
        if (tag?.entityTypes?.includes('places')) {
            return {
                ...res,
                places: [...res.places, tag],
            }
        }
        return {
            ...res,
            notPlaces: [...res.notPlaces, tag],
        }
    }, {
        places: [],
        notPlaces: [],
    });
    return [...educational, ...cities, ...places, ...notPlaces]

}

interface PageProps {
    className?: string;
    projectId?: string;
    project: Project;
    channel?: Team;
    setProject: (project: Project) => void;
    voteCollectionId?: string;
    voteEndParam?: string;
    currentCompetitionId?: string;
    tab?: string;
    setQueryParams?: (params: any, config?: any) => void;
    isProjectLoading?: boolean;
    projectSource?: any;
    computedProject: any;
    setProjectSource: (project: any) => void;
    isModer: boolean;
    isOwner?: boolean;
    isOwnerLoading?: boolean;
    isLMS?: boolean;
    profile?: any;
    isPreview: boolean;
    isProjectPreview: boolean;
    isBookProjectPreview: boolean;
    lmsModuleInfo?: any;
    competitionsExamCompleted: Competition[];
    competitionsParticipant: Competition[];
    competitionsWinner: Competition[];
    competitionFynalist: Competition[];
    isMac13: boolean;
    is992: boolean;
    is744: boolean;
    is743: boolean;
    is1200: boolean;
    vtype: string;
    isOutsideTextPosition: boolean;
    onUpdate: (t: number) => void;
    hasLgGoods?: boolean;
    lgCoverTextPost?: string[];
    currentTeam?: ITeamEntity | null;
    bookPaymentData?: any;
    additionalItems?: any[]
    collectionReprod?: any;
    isBooks?: boolean;
    isAgeyTomesh?: boolean;
    isOnlines?: boolean;
    isSuperPuper?: boolean;
    isGeograffee?: boolean;
    isCGrave?: boolean;
    isAdcrDafesNet?: boolean;
    isContinuumSite?: boolean;
    isGameDeziiign?: boolean;
    isDafes?: boolean;
    isProHSE?: boolean;
    isLoadingCard?: boolean;
    disciplineColors?: any;
    theme: any;
    repostUtils?: any;
    calculatedColor?: string;
    isCollectionVote?: boolean;
    isMobile?: boolean;
    isLmsModerationType?: boolean;
    onlyContent?: boolean;
}

const BodyOverflowStyle = createGlobalStyle`
  body {
    // overflow-y: scroll !important;
  }
`

export const Title = styled.h1<{ isAgeytomesh?: boolean, isProjectEdit?: boolean, maxTitleWidth?: number, visibleTextColor?: string }>`
  font-family: Inter, sans-serif;
  margin: 0;
  font-size: 30px;
  line-height: 33px;
  font-weight: 500;
  letter-spacing: -0.02em;
  color: ${({ visibleTextColor }) => visibleTextColor};
  max-width: ${LayoutConst.projectCover.l.w}px;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 23px;
    line-height: 27px;
    max-width: ${LayoutConst.projectCover.m.w}px;
  }

  @media (max-width: 940px) {
    max-width: ${({ maxTitleWidth }) => maxTitleWidth || 452}px;
    overflow: hidden;
    text-overflow: ellipsis;
    ${({ isAgeytomesh }) => isAgeytomesh ? css`
      color: #545453;
    ` : null} // color: ${({ theme }) => theme.projectView.titleColorMobile};
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    max-width: 100%;
    ${({ isProjectEdit }) => isProjectEdit ? css`
      font-size: 22px;
      line-height: 25px;
      font-weight: 500;
    ` : null};
  }
`;

export const LimitedLink = styled(Link)`
  max-width: 100%;
  line-height: 0.8em;
  margin-bottom: 0px !important;
  margin-right: 0px !important;

  @media (max-width: ${LayoutConst.screen.m}px) {
    //margin-bottom: 8px !important;
    &:last-child {
      //margin-bottom: px !important;
    }
  }
`

export const StatusPseudoTag = styled.div<any>`
  display: flex;
  padding: 6px 16px;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  background: #D81700;
  color: #FEFEFE;
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.3px;
  margin-bottom: ${p => p.mb !== undefined ? `${p.mb}px!important` : 0};
  margin-right: ${p => p.mr !== undefined ? `${p.mr}px!important` : '16px'};
  @media (max-width: ${LayoutConst.screen.l}px) {
    font-size: 13px;
    line-height: 16px;
  }
  @media (max-width: ${LayoutConst.screen.m}px) {
    margin-bottom: ${p => p.mb !== undefined ? `${p.mb}px!important` : 0};
    margin-right: ${p => p.mr !== undefined ? `${p.mr}px!important` : '8px'};
  }
`

export const EmptyLink = styled.div`
  max-width: 100%;
  line-height: 0.8em;
  margin-bottom: 0 !important;
  margin-right: 0 !important;
  text-decoration: none !important;

  @media (max-width: ${LayoutConst.screen.m}px) {
    &:last-child {
      margin-bottom: 6px !important;
    }
  }
`;

const ProjectContent: FC<PageProps> = ({
    projectId,
    className,
    project,
    channel,
    setProject,
    tab,
    voteCollectionId,
    voteEndParam,
    currentCompetitionId,
    setQueryParams,
    isProjectLoading,
    projectSource,
    setProjectSource,
    isModer,
    isOwner,
    isOwnerLoading,
    isLMS,
    profile,
    isPreview,
    isProjectPreview,
    lmsModuleInfo,
    isBookProjectPreview,
    competitionsExamCompleted,
    competitionsParticipant,
    competitionsWinner,
    competitionFynalist,
    isMac13,
    is992,
    is744,
    is743,
    is1200,
    vtype,
    isOutsideTextPosition,
    onUpdate,
    hasLgGoods,
    lgCoverTextPost,
    currentTeam,
    bookPaymentData,
    additionalItems,
    collectionReprod,
    isBooks,
    isAgeyTomesh,
    isOnlines,
    isSuperPuper,
    isGeograffee,
    isCGrave,
    isAdcrDafesNet,
    isContinuumSite,
    isGameDeziiign,
    isDafes,
    isProHSE,
    isLoadingCard,
    computedProject,
    disciplineColors,
    theme,
    calculatedColor,
    isCollectionVote,
    isMobile,
    isLmsModerationType,
    onlyContent,
}) => {
    const { i18n } = useTranslation();
    const history = useHistory();

    const [metaTags, setMetaTags] = useState<string[]>([]);
    const [setLongreadCounts, longreadCountData] = useLongreadCounts();
    const isMediiia = AppTester.isMediiia();

    const [isEmptyProjectTags, setIsEmptyProjectTags] = useState(false);
    const [showQueue, setShowQueue] = useState(false);
    const [longreadIsReady, setLongreadReady] = useState<any>(null);
    const [mobileOffset, setMobileOffset] = useState<number>(0);
    const modal = useModal();

    const dispatch = useDispatch()

    const lmsInfo = useSelector(selectorLMSModuleInfo);

    const courseButtons = useMemo(() => {
        return lmsInfo?.buttons || []
    }, [lmsInfo])

    //@ts-ignore
    const discipline = project?.additionalInfo?.lmsmodule_discipline;

    const onWhiteBg = !isGeograffee && !isSuperPuper && !isCGrave && !isContinuumSite && !isAdcrDafesNet;

    const isAnimatedBook = useMemo(() => (['animated', 'horizontal'].includes(project?.projectType)), [project?.projectType])

    const shouldDisplayPresentationEditor = useMemo(() => (['t-shape', 'fixed-ratio-large', 'fixed-ratio-small', 'free-type', 'animated'].includes(vtype)), [vtype])
    const maxTitleWidth = useMemo(() => {
        if (is743 || !is992 || shouldDisplayPresentationEditor) return 0;
        return window.innerWidth / 2 - 24
    }, [shouldDisplayPresentationEditor, is992, is743, window.innerWidth])

    const [pollT, setPollT] = useState(new Date().getTime())
    const [isBookBuyProccessing, setIsBookBuyProcessing] = useState(false)
    const [customPollTime, setCustomPollTime] = useState<undefined | number>(undefined)

    const [blockedState, setBlockedState] = useState({
        isBlocked: false,
        reasons: [] as number[],
        otherReason: ''
    });

    const handleBlockedStateChange = useCallback((isBlocked: boolean, reasons: number[], otherReason: string) => {
        setBlockedState({
            isBlocked,
            reasons,
            otherReason
        });
    }, []);
    const { resp: pollInfo } = useGetPollByParentEntity(isCollectionVote ? (project?.projectId || '') : '', pollT);

    const setCustomPullTime = useCallback((time: number, isFromVoteClick?: boolean) => {

        if (!pollInfo?.stages) return;
        const stageDate = pollInfo?.stages[(pollInfo?.stages?.length || 1) - 1]?.start || "";

        if (stageDate) return;

        if (isOwner && isFromVoteClick && !customPollTime) {
            setCustomPollTime(time);
            return;
        }

        if (isFromVoteClick || customPollTime) {
            return;
        }

        setPollT(time);

    }, [pollInfo?.stages, isOwner, customPollTime])

    const isGameActive = useMemo(() => pollInfo?.status === GameStatuses.active, [pollInfo]);

    const isVotingDisabled = useMemo(() => !isGameActive || isProjectPreview, [isGameActive, isProjectPreview])

    const onLongreadIsReady = (n: any) => {
        setLongreadReady(n || true)
    }

    const canViewStatus = useMemo(() => (isOwner || isModer), [isOwner, isModer]);

    const statusVisible = useMemo(() => (project && ProjectDelegate.isRejectedProject(project) && canViewStatus
    ), [project, canViewStatus])

    const shouldVisiblePurchase = useMemo(() => (isMobile && isModer && isAgeyTomesh), [isMobile, isModer, isAgeyTomesh]);


    const skipReducedVersion = ['t-shape', 'fixed-ratio-large', 'fixed-ratio-small', 'free-type'].includes(vtype);

    const competitionsFilter = useMemo(() => {
        if (profile) {
            if (isModer) {
                return {
                    initTags: true,
                    competitionStatus: [STATUSES.Open.valueOf(), STATUSES.Voting.valueOf()],
                };
            }
            else {
                return {
                    initTags: true,
                    byModeratorIds: [profile.accountId],
                    competitionStatus: [STATUSES.Open.valueOf(), STATUSES.Voting.valueOf()],
                };
            }
        }
        else {
            return null;
        }
    }, [profile, isModer]);

    useEffect(() => {
        if (competitionsFilter) {
            CompetitionAPI.GetList(competitionsFilter)
                .then((v) => v.json())
                .then((v) => API.toLang<PageModel<Competition>>(v, i18n.language))
                .then((v) => {
                    dispatch(CompetitionProjectsActions.setProjectCompetitions(v.data))
                });
        }
        else {
            dispatch(CompetitionProjectsActions.setProjectCompetitions([]));
        }
    }, [competitionsFilter, i18n]);


    useEffect(() => {
        //@ts-ignore
        if (project && project.isAgeRestricted) {
            // @ts-ignore
            const adultContentAllowed = localStorage.getItem('brgAdultContentAllowed', true)
            if (adultContentAllowed !== 'true') {
                modal.show('ageRestricted', {
                    // @ts-ignore
                    callback: (passed) => {
                        if (passed) {
                            // @ts-ignore
                            localStorage.setItem('brgAdultContentAllowed', true);
                        } else {
                            setTimeout(() => {
                                modal.hide();
                                history.goBack();
                            }, 100)

                        }
                    }
                })
            }
        }
    }, [project, history, modal])

    useEffect(() => {
        setIsBookBuyProcessing(tab === "variants");
    }, [tab]);

    useEffect(() => {
        localStorage.setItem('redirectUri', window.location.href);
        return () => {
            localStorage.setItem('redirectUri', '');
        }
    }, []);

    useEffect(() => {
        return () => {
            dispatch(clearTrackInfo())
        }
    }, [projectId])

    const votesContent = useMemo(() => {
        return {
            isAuth: !!profile && !!profile?.accountId && !isPreview,
            isSpVote: isModer,
            isCollectionVote: project?.contexts?.includes(SP_VOTE_COLLECTION_SIGN),
            projectId,
        }

    }, [profile, isModer, isPreview, projectId, voteCollectionId, project])



    const zoom = useZoom();

    const projectTags: (Tag<'Local'> & { isEducationTag: boolean, isTeamTag: boolean })[] = useMemo(() => {
        const tags = (project && project?.tags ? project.tags : []) as unknown as (Tag<'Local'> & { isEducationTag: boolean, isTeamTag: boolean })[];

        return tags.filter(TagStatusDeleted);
    }, [project]);

    const Tags = useMemo(() => {
        return projectTags.map((v) => {
            const target = (v.tagId === AGEYTOMESH_TAG_ID || v.isTeamTag) ? '_blank' : '';

            if (v.tagId === AGEYTOMESH_TAG_ID) {
                return (
                    <EmptyLink key={v.tagId}>
                        <a href={process.env.REACT_APP_URL_AGEYTOMESH} target={target} rel="noopener noreferrer" >
                            <BTag tag={v} educational={v.isEducationTag} organization={v.isTeamTag} isProjectsTag>
                                {bTag.title(v)}
                            </BTag>
                        </a>
                    </EmptyLink>
                )
            }

            if (v.isTeamTag) {
                const teamRoute = v.additionalInfo?.team_route;
                if (teamRoute) {
                    const url = teamRoute.toLowerCase().startsWith("http")
                        ? teamRoute
                        : `https://${teamRoute}`;
                    return (
                        <EmptyLink key={v.tagId}>
                            <a
                                href={url}
                                target={target}
                                rel="noopener noreferrer"
                            >
                                <BTag tag={v} educational={v.isEducationTag} organization={v.isTeamTag} isProjectsTag>
                                    {bTag.title(v)}
                                </BTag>
                            </a>
                        </EmptyLink>
                    )
                } else {
                    const teamContextName = v.additionalInfo?.team_contextname;
                    return (
                        <LimitedLink key={v.tagId} to={`/teams/${teamContextName}`} target={target} rel="noopener noreferrer" >
                            <BTag tag={v} educational={v.isEducationTag} organization={v.isTeamTag} isProjectsTag>
                                {bTag.title(v)}
                            </BTag>
                        </LimitedLink>
                    )
                }
            }

            if (v.link) {
                const raw = `${v.link}tag/${v.tagId}`;
                const url = raw.toLowerCase().startsWith("http")
                    ? raw
                    : `https://${raw}`;
                return (
                    <EmptyLink key={v.tagId}>
                        <a href={url} target={target} rel="noopener noreferrer" >
                            <BTag tag={v} educational={v.isEducationTag} organization={v.isTeamTag} isProjectsTag>
                                {bTag.title(v)}
                            </BTag>
                        </a>
                    </EmptyLink>
                )
            }

            if (isMediiia && v.entityTypes?.includes("artist")) {
                return (
                    <EmptyLink key={v.tagId}>
                        <a href={`https://gallllery.com/tc/${v.tagId}`} target={target} rel="noopener noreferrer" >
                            <BTag tag={v} educational={v.isEducationTag} organization={v.isTeamTag} isProjectsTag>
                                {bTag.title(v)}
                            </BTag>
                        </a>
                    </EmptyLink>
                );
            }

            return (
                <LimitedLink key={v.tagId} to={CreateLinkTo.tag(v.tagId)} target={target} rel="noopener noreferrer" >
                    <BTag tag={v} educational={v.isEducationTag} organization={v.isTeamTag} isProjectsTag>
                        {bTag.title(v)}
                    </BTag>
                </LimitedLink>
            );
        }
        )
    }, [projectTags, bTag])

    const shouldVisibleProtectedStatus = false;

    const presentationEditBlock = useMemo(() => {
        return (
            <ThemeProvider theme={theme}>
                <PSpresentationBlock
                    project={project}
                    isModer={isModer}
                    title={
                        isOutsideTextPosition ? (
                            //@ts-ignore
                            <PsnTitle isAgeytomesh={isAgeyTomesh} isProjectEdit={!isBooks && !isOnlines}
                                hseFonts={false}>
                                {/*@ts-ignore*/}
                                {computedProject?.title}
                            </PsnTitle>
                        ) : undefined}
                    isOutsideText={isOutsideTextPosition}
                    bottom={
                        <PSBottom isPresentation={true} isOutsideTextPosition={isOutsideTextPosition}
                            isEmptyProjectTags={isEmptyProjectTags} project={project} onShouldReload={setProject}
                            isProjectPage={!isOnlines} orientation='horizontal' isPresentationTooltip
                            channel={channel!} onBlockedStateChange={handleBlockedStateChange} />
                    }
                    //@ts-ignore
                    mobileBottom={<PsPresentationBtns project={project} isModer={isModer} isPresentation={true}
                        isOutsideTextPosition={isOutsideTextPosition} />}
                    tags={Tags}
                    //@ts-ignore
                    dialog={isAnimatedBook ? null : currentTeam ? <OrganizationApprovalDialog project={project} /> :
                        <ApprovalDialog project={project} onShouldReload={setProject} wide={!is743} onBlockedStateChange={handleBlockedStateChange} />}
                    isPreview={!!isPreview}
                />
                <ReactTooltip {...getTooltipStyles(theme)} />
            </ThemeProvider>
        )
    }, [
        currentTeam,
        computedProject,
        projectTags,
        project,
        setProject,
        isEmptyProjectTags,
        isOnlines,
        theme,
        is743,
        lgCoverTextPost,
        isPreview
    ])

    const QueueButtonsComponent = useMemo(() => {

        if (isPreview || isBookBuyProccessing) return null;

        // @ts-ignore
        if ((project?.paymentType !== PaymentStatus.PayBook || !project?.isBook) && !project?.book) {
            return hasLgGoods ? <LongreadShopButtons project={project} /> : null;
        }
        return <QueueButtons
            bookPaymentData={bookPaymentData}
            goToBookBuyProcessing={() => {
                setQueryParams?.({ tab: "variants" }, { replace: true })
                setIsBookBuyProcessing(true)
            }}
            cards={additionalItems} book={project.book || project} showQueue={showQueue} setShowQueue={(queue) => setShowQueue(queue)}
        />
    }, [isPreview, isBookBuyProccessing, project, bookPaymentData, additionalItems, showQueue, hasLgGoods, setQueryParams])

    const QueueButtonsComponentBottom = useMemo(() => {

        if (isPreview || isBookBuyProccessing) return null;

        // @ts-ignore
        if ((project?.paymentType !== PaymentStatus.PayBook || !project?.isBook) && !project?.book) {
            return hasLgGoods ? <LongreadShopButtons project={project} /> : null;
        }
        return <QueueButtons
            bookPaymentData={bookPaymentData}
            showTagsButton={false}
            goToBookBuyProcessing={() => {
                setQueryParams?.({ tab: "variants" }, { replace: true })
                setIsBookBuyProcessing(true)
            }}
            cards={additionalItems} book={project.book || project} showQueue={showQueue} setShowQueue={(queue) => setShowQueue(queue)}
        />
    }, [isPreview, isBookBuyProccessing, project, bookPaymentData, additionalItems, showQueue, hasLgGoods, setQueryParams])

    const images = getProjectImages(project, i18n.language) || [];

    const coverContent = useMemo(() => {
        if (shouldDisplayPresentationEditor) {
            return {
                firstAsCover: true,
                isPresentation: ['t-shape', 'fixed-ratio-large', 'fixed-ratio-small', 'free-type'].includes(vtype),
                onLongreadIsReady: onLongreadIsReady,
            }
        }
    }, [shouldDisplayPresentationEditor, vtype])

    const additionalContent = useMemo(
        //@ts-ignore
        () => project?.rootTeamId ? project?.rootTeam?.additionalContent : shouldDisplayPresentationEditor && project?.additionalContent, [shouldDisplayPresentationEditor, project])


    const showChaptersNavigation = useMemo(() => (project?.projectId === projectId && project?.book), [project, projectId])

    const editorPlacer = useMemo(() => (longreadIsReady && document.querySelector('.first_as_cover')), [longreadIsReady])

    const presentationEditor = useMemo(() => {
        //@ts-ignore
        if (shouldDisplayPresentationEditor && !!editorPlacer && !project?.isProjectInfoHidden) {
            return createPortal(presentationEditBlock, editorPlacer as Element)
        }
    }, [shouldDisplayPresentationEditor, editorPlacer, presentationEditBlock, project])

    const voteBlock = useMemo(() => (
        <VoteLongreadBlockWrapper justify='center' align='center'>
            <VoteBlock project={project} fullSize position={VOTE_BLOCK_POSITION.bottom} />
        </VoteLongreadBlockWrapper>
    ), [project])

    const presentationVoteBlock = useMemo(() => {
        //@ts-ignore
        if (shouldDisplayPresentationEditor && !!editorPlacer) {
            return createPortal(voteBlock, editorPlacer as Element)
        }
    }, [shouldDisplayPresentationEditor, editorPlacer, voteBlock, project])

    const shouldHideTags = useMemo(() => (!!projectTags?.length && projectTags?.length > 7), [projectTags])

    const presentationLongreadBox = useMemo(() => {

        if (project?.isBook) return null;

        // @ts-ignore
        const lmsTeam = project?.teams?.find((i) => i?.moderationType === ModerationType.LMS)
        const isLMSParticipant = (lmsTeam?.membersIDs || []).includes(profile?.accountId) || (lmsTeam?.ownersIDs || []).includes(profile?.accountId);

        if (project) {
            return (
                <ProjectLongreadWrapper isPresentation={true} vtype={vtype} hseFonts={false}>
                    <FlexBox direction="column" directionMobile="column" width="100%"
                        offsetBottom={(isLMS && (lmsModuleInfo?.themeInfos?.length === 0 || !isLMSParticipant || !lmsModuleInfo?.themeInfos)) ? (is992 ? 16 : 24) : 0}>
                        <PSLongread
                            lastLongreadBlockLink={isLMS && profile?.accountId && lmsModuleInfo?.themeInfos?.length === 0 && !lmsModuleInfo?.examInfo && lmsModuleInfo?.nextModuleLink}
                            additionalContent={additionalContent}
                            courseButtons={courseButtons}
                            pagingLimit={isLMS ? 0 : 12}
                            courseGeneralColor={getDisciplineColorFromId(discipline, disciplineColors)}
                            setPollTime={setCustomPullTime} disableVoting={isVotingDisabled} project={project}
                            // @ts-ignore
                            setMetaTags={setMetaTags} votesContent={votesContent} coverContent={coverContent}
                            onViewCurrentSlideScroll={(project.isBook /*|| !!isLmsModerationType*/) ? undefined : setLongreadCounts} />
                        {(isLMS && isLMSParticipant && lmsModuleInfo) ?
                            <LMSLongreadList project={project} /> : undefined}
                        {!!project?.limitContentCount && (longreadCountData?.count || 0) >= Number(project.limitContentCount) && (
                            <PsProtectInfo bookPaymentData={bookPaymentData} QueueButtonsComponent={QueueButtonsComponentBottom} project={project} longreadCount={longreadCountData?.count || 0} />
                        )}
                        {voteBlock}
                    </FlexBox>
                </ProjectLongreadWrapper>
            )
        }
    }, [project, vtype, isLMS, courseButtons, isProHSE, lmsModuleInfo, is992, profile?.accountId, additionalContent, discipline, disciplineColors, setCustomPullTime, isVotingDisabled, votesContent, coverContent, isLmsModerationType, setLongreadCounts, voteBlock])

    // @ts-ignore
    const visibleTextColor = tinycolor.mostReadable(calculatedColor, [Colors.geoWhite100, Colors.galBlack100]).toHexString();

    if (isAnimatedBook && !isServer) {
        return (
            <ModerationContext.Provider value={{
                project,
                toolsComponent: presentationEditBlock,
                voteBlock,
            }}>
                <MetaTags
                    title={computedProject?.title}
                    // description={metaTags}
                    images={computedProject?.titleImages}
                />
                <ChildrensBookView project={project} />
            </ModerationContext.Provider>
        )
    }

    return (
        <CommonProjectContainer>
            <BodyOverflowStyle />
            <ThemeProvider theme={theme as any}>
                {/* {chaptersPager} */}
                {/*@ts-ignore*/}
                {presentationEditor}
                {presentationVoteBlock}
                <MetaTags
                    title={computedProject?.title}
                    // description={metaTags}
                    images={computedProject?.titleImages}
                />
                <CustomBgWrapper backgroundColor={calculatedColor}>
                    <PageViewportLayout
                        vtype={vtype}
                        skipReducedVersion={skipReducedVersion}
                        offsetTop={isLMS ? 14 : ['t-shape', 'fixed-ratio-large', 'fixed-ratio-small', 'free-type'].includes(vtype)
                            ? 0 : (is992 ? 10 : isMac13 ? 12 : 14)
                        } style={{ position: 'relative' }}>
                        {shouldDisplayPresentationEditor ? presentationLongreadBox : (
                            <ProjectDisplayLayout
                                project={project}
                                canViewStatus={canViewStatus}
                                isLoading={isProjectLoading}
                                bgColor={calculatedColor}
                                blockedState={blockedState}
                                //@ts-ignore
                                image={project?.isAdaptiveCard ? <WarholCardCoverBg><WarholCardCover project={project} /></WarholCardCoverBg> : (isCollectionVote && !images?.length) ?
                                    <VoteCollectionCover project={project} /> :
                                    // @ts-ignore
                                    <PSImage competitionInfo={project.competitions} project={computedProject}
                                        onClick={zoom.show} />}
                                contextName={<ProjectContextName />}
                                title={(
                                    <Title maxTitleWidth={maxTitleWidth} isAgeytomesh={isAgeyTomesh}
                                        isProjectEdit={!isBooks && !isOnlines} visibleTextColor={visibleTextColor}>
                                        {computedProject.title}
                                    </Title>
                                )}
                                author={<PSAuthor theme={theme} project={project} />}
                                isOwner={isOwner}
                                shouldHideTags={shouldHideTags}
                                purchase={<ProjectPurchase project={project} isModer={shouldVisiblePurchase} />}
                                editorTags={<TagsEditor project={project} setProject={setProject}
                                    projectSource={projectSource}
                                    setProjectSource={setProjectSource} />}
                                point={<ProjectPoint project={project} />}
                                mobileOffset={mobileOffset}
                                tags={Tags}
                                team={<PSTeam project={computedProject} raw={project} />}
                                bottom={isBookBuyProccessing ? undefined :
                                    <PSBottom queueButton={QueueButtonsComponent} reloadProject={onUpdate}
                                        pollInfo={pollInfo} isEmptyProjectTags={false} project={project}
                                        onShouldReload={setProject} isProjectPage={!isOnlines}
                                        isPresentationTooltip={shouldDisplayPresentationEditor}
                                        isPresentation={shouldDisplayPresentationEditor}
                                        iSBookMainPage={project?.isBook} isOwner={isOwner} channel={channel!}
                                        onBlockedStateChange={handleBlockedStateChange} />}
                                //@ts-ignore
                                queue={((project?.book?.paymentType === PaymentStatus.PayBook || project?.paymentType === PaymentStatus.PayBook) && showQueue) && (project?.isBook || project?.book) &&
                                    <QueueNew
                                        currentQueuePoint={{ number: 1, type: QueueCircleType.current }}
                                        mode={QueueMode.view}
                                        rate={QueueRate.high}
                                        isBook
                                        cardsLength={additionalItems?.length || 0}
                                        userQueuePoints={[]} />}
                                subscribeInfo={<SubscribeInfo project={project} />}
                                roomLaunchBlock={<RoomLaunchBlockView
                                    selectedTags={[...(project?.tags || []), ...((project as any)?.requiredTags || [])].map(tag => tag.tagId)}
                                    projectId={project?.projectId}
                                />}
                                //@ts-ignore
                                longread={project?.isBook ? <PSChapters isLoading={isProjectLoading} project={project}
                                    disabled={isBookProjectPreview} /> :
                                    <PSLongread setPollTime={setCustomPullTime} disableVoting={isVotingDisabled}
                                        project={project} setMetaTags={setMetaTags}
                                        // @ts-ignore
                                        votesContent={votesContent} /*onZoom={zoom.show}*/
                                        protectInfoComponent={<PsProtectInfo
                                            limitContentCount={project?.limitContentCount}
                                            bookPaymentData={bookPaymentData}
                                            QueueButtonsComponent={QueueButtonsComponentBottom}
                                            project={project}
                                            longreadCount={longreadCountData?.count || 0}

                                        />}
                                        courseButtons={courseButtons}
                                        limitContentCount={project?.limitContentCount}
                                        pagingLimit={isLMS ? 0 : 12}
                                        onViewCurrentSlideScroll={project.isBook ? undefined : setLongreadCounts} />}
                                moreTitle={<PSMoreTitle project={project} />}
                                likesSticker={<StickyActionBar setMobileOffset={setMobileOffset} project={project}
                                    isModer={isModer} />}
                                statusVisible={statusVisible}
                                gameInfo={(isCollectionVote && !isPreview &&
                                    <ProjectGameInfo pollInfo={pollInfo} customPollTime={customPollTime}
                                        offsetTop={mobileOffset} bgColor={calculatedColor}
                                        isOwner={isOwner} projectId={project?.projectId} />) || undefined}
                                isCollectionVote={isCollectionVote}
                                inPartExam={<InPartExam project={project}
                                    competitionsExamCompleted={competitionsExamCompleted} />}
                                inPartCompetition={(
                                    <InPartCompetition
                                        competitionsParticipant={competitionsParticipant}
                                        competitionsWinner={competitionsWinner}
                                        competitionFynalist={competitionFynalist}
                                    />
                                )}
                                studentProject={
                                    <StudentProjectBlock project={project} />
                                }
                                // placeElement={<PlaceIconComponent competitionsWinner={competitionsWinner}/>}
                                // у организаций будет отдельная плашка модерации
                                dialog={currentTeam ? <OrganizationApprovalDialog project={project} /> :
                                    <ApprovalDialog project={project} reloadProject={onUpdate} onBlockedStateChange={handleBlockedStateChange} />}
                                bookBuyProcessingComponent={isBookBuyProccessing ?
                                    <BookBuyProcessingComponent bookPaymentData={bookPaymentData} /> : undefined}
                                protectStatus={<>
                                    <ProtectStatus project={project} visible={!!shouldVisibleProtectedStatus} />
                                </>}
                                bookmarkButtonMobile={<BookmarkButtonProjectPage entityId={project.projectId}
                                    entityType='project' />}
                            />
                        )}
                        {isLoadingCard ? (
                            <FlexBox
                                gx={isMobile ? 0 : 24}
                                gy={isMobile ? 24 : 0}
                                directionMobile="column"
                                justify="center"
                                align="center"
                                style={{ margin: "24px 0" }}
                            >
                                <Skeleton width={200} height={160} />
                                <Skeleton width={200} height={160} />
                                <Skeleton width={200} height={160} />
                                <Skeleton width={200} height={160} />
                            </FlexBox>
                        ) : (
                            //хардкод. Убрать isBook ,когда попросит нурс
                            collectionReprod?.length > 0 && !!project?.isBook && (
                                <BookCardsWithPay cards={collectionReprod} />
                            )
                        )}
                        <PSShop project={project} />
                        {!onlyContent && (
                            <PSBottomActions
                                tagsCount={projectTags?.length}
                                tags={Tags}
                                isLoading={isProjectLoading}
                                isEmptyProjectTags={isEmptyProjectTags}
                                theme={theme}
                                project={project}
                                titleVisible={!isPreview}
                                approveDialog={coverContent && project?.status !== 11 ? <ApprovalDialog project={project} isBottomMenu
                                    wide={shouldDisplayPresentationEditor && !is743} /> : null}
                            />
                        )}
                        {showChaptersNavigation &&
                            <ChaptersNavigation currentChapter={project} position={Position.bottom} />}
                        {projectTags.length > 0 && !isLMS && !onlyContent &&
                            <PsOtherProjects setIsEmptyProjectTags={setIsEmptyProjectTags} project={project} />}
                    </PageViewportLayout>
                </CustomBgWrapper>
                <ReactTooltip {...(isDafes || onWhiteBg ? tooptipStylesWhite : getTooltipStyles(theme as any))} />
                {!isLMS && <ScrollUpZone isPresentation={coverContent?.isPresentation} />}
                {project?.isBook || isLMS ? undefined :
                    <LongreadCountViewer isCollectionVote={isCollectionVote} data={longreadCountData} />}
                {isCollectionVote && !isPreview && <div id="game-info-portal" />}
                {isLMS && <div id="theme-nav-portal" />}
            </ThemeProvider>
        </CommonProjectContainer>
    );
};

export default memo(ProjectContent);
import { FC, memo, useCallback, useEffect, useMemo, useState, lazy } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Colors, FlexBox, Skeleton } from '@brg/ui';
import { API, Competition, CompetitionAPI, PageModel, Project, Tag, Team } from '@brg/api';
import ReactTooltip from 'react-tooltip';
import styled, { ThemeProvider, css, createGlobalStyle } from 'styled-components';
import StickyActionBar from 'shared/components/stickyActionBar';
import ProjectDisplayLayout, { VoteLongreadBlockWrapper } from '../../components/template/project-display-layout';
import { getProjectImages, PSImage } from './sections/ps-image';
import { PSAuthor } from './sections/ps-author';
import { PSBottom, VOTE_BLOCK_POSITION } from './sections/ps-bottom';
import { PSTeam } from './sections/ps-team';
import { PSLongread } from './sections/ps-longread';
import { PSMoreTitle } from './sections/ps-more-title';
import { PageViewportLayout } from '../../components/template/page-template';
import { RoomLaunchBlockView } from '../projectEdit/components/RoomLaunchBlock';
import { CreateLinkTo } from '../../constants/linkTo';
import { bTag, LayoutConst, useModal, useZoom } from '../../../core';
import { BTag } from '../../../core/components';
import PsOtherProjects from './sections/ps-other-projects';
import { AGEYTOMESH_TAG_ID } from "../../constants/misc";
import { ScrollUpZone } from "../../components/__FOX__/NAV/src/scroll-up-zone";
import { useLongreadCounts } from 'shared/hooks/useLongreadCounts';
import { LongreadCountViewer } from 'shared/components/__FOX__/NAV/src/longread-count-viewer';
import { ChaptersNavigation, Position } from '_deziiign/books/core/components/chaptersNavigation/ChaptersNavigation';
import { TagStatusDeleted } from 'shared/helpers/tagStatus';
import { InPartCompetition } from './components/InPartCompetition';
import { createPortal } from 'react-dom';
import { ProjectStatus } from './components/ProjectStatus';
import { PSBottomActions } from './sections/ps-bottom-actions';
import ApprovalDialog from './components/ApprovalDialog';
import { PSChapters } from '_deziiign/books/pages/sections/ps-chapters';
import { ProjectPoint } from './components/ProjectPoint';
import OrganizationApprovalDialog from "./components/OrganizationApprovalDialog";
import { ProjectPurchase } from './components/ProjectPurchase';
import { ProjectContextName } from './components/ProjectContextName';
import { ProtectStatus } from './sections/ps-protect-status';
import { BookmarkButtonProjectPage } from 'shared/components/bookmarkButtonOnProject/BookmarkButtonProjectPage';
import { CustomBgWrapper } from "../../components/CustomBgWrapper/CustomBgWrapper";
import { ProjectDelegate } from 'project-delegate';
import { CommonProjectContainer, ProjectLongreadWrapper, PsnTitle } from './styles';
import { PSpresentationBlock } from './sections/ps-presentation-block';
import { PsPresentationBtns } from './sections/ps-presentation-btns';
import { SP_VOTE_COLLECTION_SIGN } from '../VotesAdmin/VotesAdminPage';
import { VoteCollectionCover } from '../projectEdit/components/VoteCollectionCover/VoteCollectionCover';
import { useGetPollByParentEntity } from "../../hooks/api/useGetPollByParentEntity";
import { ProjectGameInfo } from "./components/ProjectGameInfo";
import { GameStatuses } from "../../constants/GameStatuses";
import { PSShop } from "./sections/ps-shop";
import { ModerationType } from "../teams/const/ModerationTypes";
import LMSLongreadList from "./components/LMSLongreadList";
import { getTooltipStyles, tooptipStylesWhite } from 'shared/constants/tooptipStyles';
import { WarholCardCover, WarholCardCoverBg } from "../../components/WarholCardCover/WarholCardCover";
import { BookCardsWithPay } from "../../../_deziiign/books/pages/BookEdit/components/BookCards/BookCards";
import { QueueMode, QueueNew } from "../../features/QueuePaymenrt/components/Queue/New/QueueNew";
import {
    QueueCircleType,
    QueueRate
} from "../../features/QueuePaymenrt/components/Queue/New/components/QueueLineNew/QueueLineNew";
import { PaymentStatus } from "../../../_deziiign/books/pages/BookEdit/BookEdit";
import { QueueButtons } from "./components/QueueButtons";
import { LongreadShopButtons } from "../../components/LongreadShopButtons";
import VoteBlock from './components/VoteBlock/VoteBlock';
import { InPartExam } from "./components/InPartExam";
import { PsProtectInfo } from './sections/ps-protect-info';
import { SubscribeInfo } from './components/SubscribeInfo';
import { getDisciplineColorFromId } from "../../helpers/LMS/getDisciplineColorFromId";
import tinycolor from 'tinycolor2';
import { BookBuyProcessingComponent } from "./components/BookBuyProcessingComponent";
import { TagsEditor } from "./components/TagsEditor";
import { ITeamEntity } from "../../hooks/useGetCurrentTeam";
import { isServer } from "../../constants/isServer";
import { AppTester } from 'supporting';
import { STATUSES } from '_competition/const';
import { CompetitionProjectsActions, CompetitionProjectsSelector } from 'shared/reducers/CompetitionProjects';
import { useDispatch, useSelector } from 'react-redux';
import { selectorLMSModuleInfo } from 'shared/reducers/LMSSlice';
import { StudentProjectBlock } from './components/StudentProjectBlock';
import ModerationContext from 'shared/contexts/ModerationContext';

const ChildrensBookView = lazy(() => import('../ChildrensBooks/BookView/ChildrensBookView'));

const MetaTags = isServer
    ? FlexBox
    : lazy(() => import("../../components/MetaTags"))

import { clearTrackInfo } from 'shared/components/AudioPlayer/reducers/AudioSlice';

export const sortTags = (tags: Tag[]) => {
    //@ts-ignore
    const { educational, rest } = tags.reduce((res, tag) => {
        //@ts-ignore
        if (tag?.isEducationTag) {
            return {
                ...res,
                educational: [...res.educational, tag],
            }
        }
        return {
            ...res,
            rest: [...res.rest, tag],
        }
    }, {
        educational: [],
        rest: [],
    });
    //@ts-ignore
    const { cities, notCities } = rest.reduce((res, tag) => {
        if (tag?.entityTypes?.includes('cities')) {
            return {
                ...res,
                cities: [...res.cities, tag],
            }
        }
        return {
            ...res,
            notCities: [...res.notCities, tag],
        }
    }, {
        cities: [],
        notCities: [],
    });
    //@ts-ignore
    const { places, notPlaces } = notCities.reduce((res, tag) => {
        if (tag?.entityTypes?.includes('places')) {
            return {
                ...res,
                places: [...res.places, tag],
            }
        }
        return {
            ...res,
            notPlaces: [...res.notPlaces, tag],
        }
    }, {
        places: [],
        notPlaces: [],
    });
    return [...educational, ...cities, ...places, ...notPlaces]

}

interface PageProps {
    className?: string;
    projectId?: string;
    project: Project;
    channel?: Team;
    setProject: (project: Project) => void;
    voteCollectionId?: string;
    voteEndParam?: string;
    currentCompetitionId?: string;
    tab?: string;
    setQueryParams?: (params: any, config?: any) => void;
    isProjectLoading?: boolean;
    projectSource?: any;
    computedProject: any;
    setProjectSource: (project: any) => void;
    isModer: boolean;
    isOwner?: boolean;
    isOwnerLoading?: boolean;
    isLMS?: boolean;
    profile?: any;
    isPreview: boolean;
    isProjectPreview: boolean;
    isBookProjectPreview: boolean;
    lmsModuleInfo?: any;
    competitionsExamCompleted: Competition[];
    competitionsParticipant: Competition[];
    competitionsWinner: Competition[];
    competitionFynalist: Competition[];
    isMac13: boolean;
    is992: boolean;
    is744: boolean;
    is743: boolean;
    is1200: boolean;
    vtype: string;
    isOutsideTextPosition: boolean;
    onUpdate: (t: number) => void;
    hasLgGoods?: boolean;
    lgCoverTextPost?: string[];
    currentTeam?: ITeamEntity | null;
    bookPaymentData?: any;
    additionalItems?: any[]
    collectionReprod?: any;
    isBooks?: boolean;
    isAgeyTomesh?: boolean;
    isOnlines?: boolean;
    isSuperPuper?: boolean;
    isGeograffee?: boolean;
    isCGrave?: boolean;
    isAdcrDafesNet?: boolean;
    isContinuumSite?: boolean;
    isGameDeziiign?: boolean;
    isDafes?: boolean;
    isProHSE?: boolean;
    isLoadingCard?: boolean;
    disciplineColors?: any;
    theme: any;
    repostUtils?: any;
    calculatedColor?: string;
    isCollectionVote?: boolean;
    isMobile?: boolean;
    isLmsModerationType?: boolean;
    onlyContent?: boolean;
}

const BodyOverflowStyle = createGlobalStyle`
  body {
    // overflow-y: scroll !important;
  }
`

export const Title = styled.h1<{ isAgeytomesh?: boolean, isProjectEdit?: boolean, maxTitleWidth?: number, visibleTextColor?: string }>`
  font-family: Inter, sans-serif;
  margin: 0;
  font-size: 30px;
  line-height: 33px;
  font-weight: 500;
  letter-spacing: -0.02em;
  color: ${({ visibleTextColor }) => visibleTextColor};
  max-width: ${LayoutConst.projectCover.l.w}px;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 23px;
    line-height: 27px;
    max-width: ${LayoutConst.projectCover.m.w}px;
  }

  @media (max-width: 940px) {
    max-width: ${({ maxTitleWidth }) => maxTitleWidth || 452}px;
    overflow: hidden;
    text-overflow: ellipsis;
    ${({ isAgeytomesh }) => isAgeytomesh ? css`
      color: #545453;
    ` : null} // color: ${({ theme }) => theme.projectView.titleColorMobile};
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    max-width: 100%;
    ${({ isProjectEdit }) => isProjectEdit ? css`
      font-size: 22px;
      line-height: 25px;
      font-weight: 500;
    ` : null};
  }
`;

export const LimitedLink = styled(Link)`
  max-width: 100%;
  line-height: 0.8em;
  margin-bottom: 0px !important;
  margin-right: 0px !important;

  @media (max-width: ${LayoutConst.screen.m}px) {
    //margin-bottom: 8px !important;
    &:last-child {
      //margin-bottom: px !important;
    }
  }
`

export const StatusPseudoTag = styled.div<any>`
  display: flex;
  padding: 6px 16px;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  background: #D81700;
  color: #FEFEFE;
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.3px;
  margin-bottom: ${p => p.mb !== undefined ? `${p.mb}px!important` : 0};
  margin-right: ${p => p.mr !== undefined ? `${p.mr}px!important` : '16px'};
  @media (max-width: ${LayoutConst.screen.l}px) {
    font-size: 13px;
    line-height: 16px;
  }
  @media (max-width: ${LayoutConst.screen.m}px) {
    margin-bottom: ${p => p.mb !== undefined ? `${p.mb}px!important` : 0};
    margin-right: ${p => p.mr !== undefined ? `${p.mr}px!important` : '8px'};
  }
`

export const EmptyLink = styled.div`
  max-width: 100%;
  line-height: 0.8em;
  margin-bottom: 0 !important;
  margin-right: 0 !important;
  text-decoration: none !important;

  @media (max-width: ${LayoutConst.screen.m}px) {
    &:last-child {
      margin-bottom: 6px !important;
    }
  }
`;

const ProjectContent: FC<PageProps> = ({
    projectId,
    className,
    project,
    channel,
    setProject,
    tab,
    voteCollectionId,
    voteEndParam,
    currentCompetitionId,
    setQueryParams,
    isProjectLoading,
    projectSource,
    setProjectSource,
    isModer,
    isOwner,
    isOwnerLoading,
    isLMS,
    profile,
    isPreview,
    isProjectPreview,
    lmsModuleInfo,
    isBookProjectPreview,
    competitionsExamCompleted,
    competitionsParticipant,
    competitionsWinner,
    competitionFynalist,
    isMac13,
    is992,
    is744,
    is743,
    is1200,
    vtype,
    isOutsideTextPosition,
    onUpdate,
    hasLgGoods,
    lgCoverTextPost,
    currentTeam,
    bookPaymentData,
    additionalItems,
    collectionReprod,
    isBooks,
    isAgeyTomesh,
    isOnlines,
    isSuperPuper,
    isGeograffee,
    isCGrave,
    isAdcrDafesNet,
    isContinuumSite,
    isGameDeziiign,
    isDafes,
    isProHSE,
    isLoadingCard,
    computedProject,
    disciplineColors,
    theme,
    calculatedColor,
    isCollectionVote,
    isMobile,
    isLmsModerationType,
    onlyContent,
}) => {
    const { i18n } = useTranslation();
    const history = useHistory();

    const [metaTags, setMetaTags] = useState<string[]>([]);
    const [setLongreadCounts, longreadCountData] = useLongreadCounts();
    const isMediiia = AppTester.isMediiia();

    const [isEmptyProjectTags, setIsEmptyProjectTags] = useState(false);
    const [showQueue, setShowQueue] = useState(false);
    const [longreadIsReady, setLongreadReady] = useState<any>(null);
    const [mobileOffset, setMobileOffset] = useState<number>(0);
    const modal = useModal();

    const dispatch = useDispatch()

    const lmsInfo = useSelector(selectorLMSModuleInfo);

    const courseButtons = useMemo(() => {
        return lmsInfo?.buttons || []
    }, [lmsInfo])

    //@ts-ignore
    const discipline = project?.additionalInfo?.lmsmodule_discipline;

    const onWhiteBg = !isGeograffee && !isSuperPuper && !isCGrave && !isContinuumSite && !isAdcrDafesNet;

    const isAnimatedBook = useMemo(() => (['animated', 'horizontal'].includes(project?.projectType)), [project?.projectType])

    const shouldDisplayPresentationEditor = useMemo(() => (['t-shape', 'fixed-ratio-large', 'fixed-ratio-small', 'free-type', 'animated'].includes(vtype)), [vtype])
    const maxTitleWidth = useMemo(() => {
        if (is743 || !is992 || shouldDisplayPresentationEditor) return 0;
        return window.innerWidth / 2 - 24
    }, [shouldDisplayPresentationEditor, is992, is743, window.innerWidth])

    const [pollT, setPollT] = useState(new Date().getTime())
    const [isBookBuyProccessing, setIsBookBuyProcessing] = useState(false)
    const [customPollTime, setCustomPollTime] = useState<undefined | number>(undefined)

    const [blockedState, setBlockedState] = useState({
        isBlocked: false,
        reasons: [] as number[],
        otherReason: ''
    });

    const handleBlockedStateChange = useCallback((isBlocked: boolean, reasons: number[], otherReason: string) => {
        setBlockedState({
            isBlocked,
            reasons,
            otherReason
        });
    }, []);
    const { resp: pollInfo } = useGetPollByParentEntity(isCollectionVote ? (project?.projectId || '') : '', pollT);

    const setCustomPullTime = useCallback((time: number, isFromVoteClick?: boolean) => {

        if (!pollInfo?.stages) return;
        const stageDate = pollInfo?.stages[(pollInfo?.stages?.length || 1) - 1]?.start || "";

        if (stageDate) return;

        if (isOwner && isFromVoteClick && !customPollTime) {
            setCustomPollTime(time);
            return;
        }

        if (isFromVoteClick || customPollTime) {
            return;
        }

        setPollT(time);

    }, [pollInfo?.stages, isOwner, customPollTime])

    const isGameActive = useMemo(() => pollInfo?.status === GameStatuses.active, [pollInfo]);

    const isVotingDisabled = useMemo(() => !isGameActive || isProjectPreview, [isGameActive, isProjectPreview])

    const onLongreadIsReady = (n: any) => {
        setLongreadReady(n || true)
    }

    const canViewStatus = useMemo(() => (isOwner || isModer), [isOwner, isModer]);

    const statusVisible = useMemo(() => (project && ProjectDelegate.isRejectedProject(project) && canViewStatus
    ), [project, canViewStatus])

    const shouldVisiblePurchase = useMemo(() => (isMobile && isModer && isAgeyTomesh), [isMobile, isModer, isAgeyTomesh]);


    const skipReducedVersion = ['t-shape', 'fixed-ratio-large', 'fixed-ratio-small', 'free-type'].includes(vtype);

    const competitionsFilter = useMemo(() => {
        if (profile) {
            if (isModer) {
                return {
                    initTags: true,
                    competitionStatus: [STATUSES.Open.valueOf(), STATUSES.Voting.valueOf()],
                };
            }
            else {
                return {
                    initTags: true,
                    byModeratorIds: [profile.accountId],
                    competitionStatus: [STATUSES.Open.valueOf(), STATUSES.Voting.valueOf()],
                };
            }
        }
        else {
            return null;
        }
    }, [profile, isModer]);

    useEffect(() => {
        if (competitionsFilter) {
            CompetitionAPI.GetList(competitionsFilter)
                .then((v) => v.json())
                .then((v) => API.toLang<PageModel<Competition>>(v, i18n.language))
                .then((v) => {
                    dispatch(CompetitionProjectsActions.setProjectCompetitions(v.data))
                });
        }
        else {
            dispatch(CompetitionProjectsActions.setProjectCompetitions([]));
        }
    }, [competitionsFilter, i18n]);


    useEffect(() => {
        //@ts-ignore
        if (project && project.isAgeRestricted) {
            // @ts-ignore
            const adultContentAllowed = localStorage.getItem('brgAdultContentAllowed', true)
            if (adultContentAllowed !== 'true') {
                modal.show('ageRestricted', {
                    // @ts-ignore
                    callback: (passed) => {
                        if (passed) {
                            // @ts-ignore
                            localStorage.setItem('brgAdultContentAllowed', true);
                        } else {
                            setTimeout(() => {
                                modal.hide();
                                history.goBack();
                            }, 100)

                        }
                    }
                })
            }
        }
    }, [project, history, modal])

    useEffect(() => {
        setIsBookBuyProcessing(tab === "variants");
    }, [tab]);

    useEffect(() => {
        localStorage.setItem('redirectUri', window.location.href);
        return () => {
            localStorage.setItem('redirectUri', '');
        }
    }, []);

    useEffect(() => {
        return () => {
            dispatch(clearTrackInfo())
        }
    }, [projectId])

    const votesContent = useMemo(() => {
        return {
            isAuth: !!profile && !!profile?.accountId && !isPreview,
            isSpVote: isModer,
            isCollectionVote: project?.contexts?.includes(SP_VOTE_COLLECTION_SIGN),
            projectId,
        }

    }, [profile, isModer, isPreview, projectId, voteCollectionId, project])



    const zoom = useZoom();

    const projectTags: (Tag<'Local'> & { isEducationTag: boolean, isTeamTag: boolean })[] = useMemo(() => {
        const tags = (project && project?.tags ? project.tags : []) as unknown as (Tag<'Local'> & { isEducationTag: boolean, isTeamTag: boolean })[];

        return tags.filter(TagStatusDeleted);
    }, [project]);

    const Tags = useMemo(() => {
        return projectTags.map((v) => {
            const target = (v.tagId === AGEYTOMESH_TAG_ID || v.isTeamTag) ? '_blank' : '';

            if (v.tagId === AGEYTOMESH_TAG_ID) {
                return (
                    <EmptyLink key={v.tagId}>
                        <a href={process.env.REACT_APP_URL_AGEYTOMESH} target={target} rel="noopener noreferrer" >
                            <BTag tag={v} educational={v.isEducationTag} organization={v.isTeamTag} isProjectsTag>
                                {bTag.title(v)}
                            </BTag>
                        </a>
                    </EmptyLink>
                )
            }

            if (v.isTeamTag) {
                const teamRoute = v.additionalInfo?.team_route;
                if (teamRoute) {
                    const url = teamRoute.toLowerCase().startsWith("http")
                        ? teamRoute
                        : `https://${teamRoute}`;
                    return (
                        <EmptyLink key={v.tagId}>
                            <a
                                href={url}
                                target={target}
                                rel="noopener noreferrer"
                            >
                                <BTag tag={v} educational={v.isEducationTag} organization={v.isTeamTag} isProjectsTag>
                                    {bTag.title(v)}
                                </BTag>
                            </a>
                        </EmptyLink>
                    )
                } else {
                    const teamContextName = v.additionalInfo?.team_contextname;
                    return (
                        <LimitedLink key={v.tagId} to={`/teams/${teamContextName}`} target={target} rel="noopener noreferrer" >
                            <BTag tag={v} educational={v.isEducationTag} organization={v.isTeamTag} isProjectsTag>
                                {bTag.title(v)}
                            </BTag>
                        </LimitedLink>
                    )
                }
            }

            if (v.link) {
                const raw = `${v.link}tag/${v.tagId}`;
                const url = raw.toLowerCase().startsWith("http")
                    ? raw
                    : `https://${raw}`;
                return (
                    <EmptyLink key={v.tagId}>
                        <a href={url} target={target} rel="noopener noreferrer" >
                            <BTag tag={v} educational={v.isEducationTag} organization={v.isTeamTag} isProjectsTag>
                                {bTag.title(v)}
                            </BTag>
                        </a>
                    </EmptyLink>
                )
            }

            if (isMediiia && v.entityTypes?.includes("artist")) {
                return (
                    <EmptyLink key={v.tagId}>
                        <a href={`https://gallllery.com/tc/${v.tagId}`} target={target} rel="noopener noreferrer" >
                            <BTag tag={v} educational={v.isEducationTag} organization={v.isTeamTag} isProjectsTag>
                                {bTag.title(v)}
                            </BTag>
                        </a>
                    </EmptyLink>
                );
            }

            return (
                <LimitedLink key={v.tagId} to={CreateLinkTo.tag(v.tagId)} target={target} rel="noopener noreferrer" >
                    <BTag tag={v} educational={v.isEducationTag} organization={v.isTeamTag} isProjectsTag>
                        {bTag.title(v)}
                    </BTag>
                </LimitedLink>
            );
        }
        )
    }, [projectTags, bTag])

    const shouldVisibleProtectedStatus = false;

    const presentationEditBlock = useMemo(() => {
        return (
            <ThemeProvider theme={theme}>
                <PSpresentationBlock
                    project={project}
                    isModer={isModer}
                    title={
                        isOutsideTextPosition ? (
                            //@ts-ignore
                            <PsnTitle isAgeytomesh={isAgeyTomesh} isProjectEdit={!isBooks && !isOnlines}
                                hseFonts={false}>
                                {/*@ts-ignore*/}
                                {computedProject?.title}
                            </PsnTitle>
                        ) : undefined}
                    isOutsideText={isOutsideTextPosition}
                    bottom={
                        <PSBottom isPresentation={true} isOutsideTextPosition={isOutsideTextPosition}
                            isEmptyProjectTags={isEmptyProjectTags} project={project} onShouldReload={setProject}
                            isProjectPage={!isOnlines} orientation='horizontal' isPresentationTooltip
                            channel={channel!} onBlockedStateChange={handleBlockedStateChange} />
                    }
                    //@ts-ignore
                    mobileBottom={<PsPresentationBtns project={project} isModer={isModer} isPresentation={true}
                        isOutsideTextPosition={isOutsideTextPosition} />}
                    tags={Tags}
                    //@ts-ignore
                    dialog={isAnimatedBook ? null : currentTeam ? <OrganizationApprovalDialog project={project} /> :
                        <ApprovalDialog project={project} onShouldReload={setProject} wide={!is743} onBlockedStateChange={handleBlockedStateChange} />}
                    isPreview={!!isPreview}
                />
                <ReactTooltip {...getTooltipStyles(theme)} />
            </ThemeProvider>
        )
    }, [
        currentTeam,
        computedProject,
        projectTags,
        project,
        setProject,
        isEmptyProjectTags,
        isOnlines,
        theme,
        is743,
        lgCoverTextPost,
        isPreview
    ])

    const QueueButtonsComponent = useMemo(() => {

        if (isPreview || isBookBuyProccessing) return null;

        // @ts-ignore
        if ((project?.paymentType !== PaymentStatus.PayBook || !project?.isBook) && !project?.book) {
            return hasLgGoods ? <LongreadShopButtons project={project} /> : null;
        }
        return <QueueButtons
            bookPaymentData={bookPaymentData}
            goToBookBuyProcessing={() => {
                setQueryParams?.({ tab: "variants" }, { replace: true })
                setIsBookBuyProcessing(true)
            }}
            cards={additionalItems} book={project.book || project} showQueue={showQueue} setShowQueue={(queue) => setShowQueue(queue)}
        />
    }, [isPreview, isBookBuyProccessing, project, bookPaymentData, additionalItems, showQueue, hasLgGoods, setQueryParams])

    const QueueButtonsComponentBottom = useMemo(() => {

        if (isPreview || isBookBuyProccessing) return null;

        // @ts-ignore
        if ((project?.paymentType !== PaymentStatus.PayBook || !project?.isBook) && !project?.book) {
            return hasLgGoods ? <LongreadShopButtons project={project} /> : null;
        }
        return <QueueButtons
            bookPaymentData={bookPaymentData}
            showTagsButton={false}
            goToBookBuyProcessing={() => {
                setQueryParams?.({ tab: "variants" }, { replace: true })
                setIsBookBuyProcessing(true)
            }}
            cards={additionalItems} book={project.book || project} showQueue={showQueue} setShowQueue={(queue) => setShowQueue(queue)}
        />
    }, [isPreview, isBookBuyProccessing, project, bookPaymentData, additionalItems, showQueue, hasLgGoods, setQueryParams])

    const images = getProjectImages(project, i18n.language) || [];

    const coverContent = useMemo(() => {
        if (shouldDisplayPresentationEditor) {
            return {
                firstAsCover: true,
                isPresentation: ['t-shape', 'fixed-ratio-large', 'fixed-ratio-small', 'free-type'].includes(vtype),
                onLongreadIsReady: onLongreadIsReady,
            }
        }
    }, [shouldDisplayPresentationEditor, vtype])

    const additionalContent = useMemo(
        //@ts-ignore
        () => project?.rootTeamId ? project?.rootTeam?.additionalContent : shouldDisplayPresentationEditor && project?.additionalContent, [shouldDisplayPresentationEditor, project])


    const showChaptersNavigation = useMemo(() => (project?.projectId === projectId && project?.book), [project, projectId])

    const editorPlacer = useMemo(() => (longreadIsReady && document.querySelector('.first_as_cover')), [longreadIsReady])

    const presentationEditor = useMemo(() => {
        //@ts-ignore
        if (shouldDisplayPresentationEditor && !!editorPlacer && !project?.isProjectInfoHidden) {
            return createPortal(presentationEditBlock, editorPlacer as Element)
        }
    }, [shouldDisplayPresentationEditor, editorPlacer, presentationEditBlock, project])

    const voteBlock = useMemo(() => (
        <VoteLongreadBlockWrapper justify='center' align='center'>
            <VoteBlock project={project} fullSize position={VOTE_BLOCK_POSITION.bottom} />
        </VoteLongreadBlockWrapper>
    ), [project])

    const presentationVoteBlock = useMemo(() => {
        //@ts-ignore
        if (shouldDisplayPresentationEditor && !!editorPlacer) {
            return createPortal(voteBlock, editorPlacer as Element)
        }
    }, [shouldDisplayPresentationEditor, editorPlacer, voteBlock, project])

    const shouldHideTags = useMemo(() => (!!projectTags?.length && projectTags?.length > 7), [projectTags])

    const presentationLongreadBox = useMemo(() => {

        if (project?.isBook) return null;

        // @ts-ignore
        const lmsTeam = project?.teams?.find((i) => i?.moderationType === ModerationType.LMS)
        const isLMSParticipant = (lmsTeam?.membersIDs || []).includes(profile?.accountId) || (lmsTeam?.ownersIDs || []).includes(profile?.accountId);

        if (project) {
            return (
                <ProjectLongreadWrapper isPresentation={true} vtype={vtype} hseFonts={false}>
                    <FlexBox direction="column" directionMobile="column" width="100%"
                        offsetBottom={(isLMS && (lmsModuleInfo?.themeInfos?.length === 0 || !isLMSParticipant || !lmsModuleInfo?.themeInfos)) ? (is992 ? 16 : 24) : 0}>
                        <PSLongread
                            lastLongreadBlockLink={isLMS && profile?.accountId && lmsModuleInfo?.themeInfos?.length === 0 && !lmsModuleInfo?.examInfo && lmsModuleInfo?.nextModuleLink}
                            additionalContent={additionalContent}
                            courseButtons={courseButtons}
                            pagingLimit={isLMS ? 0 : 12}
                            courseGeneralColor={getDisciplineColorFromId(discipline, disciplineColors)}
                            setPollTime={setCustomPullTime} disableVoting={isVotingDisabled} project={project}
                            // @ts-ignore
                            setMetaTags={setMetaTags} votesContent={votesContent} coverContent={coverContent}
                            onViewCurrentSlideScroll={(project.isBook /*|| !!isLmsModerationType*/) ? undefined : setLongreadCounts} />
                        {(isLMS && isLMSParticipant && lmsModuleInfo) ?
                            <LMSLongreadList project={project} /> : undefined}
                        {!!project?.limitContentCount && (longreadCountData?.count || 0) >= Number(project.limitContentCount) && (
                            <PsProtectInfo bookPaymentData={bookPaymentData} QueueButtonsComponent={QueueButtonsComponentBottom} project={project} longreadCount={longreadCountData?.count || 0} />
                        )}
                        {voteBlock}
                    </FlexBox>
                </ProjectLongreadWrapper>
            )
        }
    }, [project, vtype, isLMS, courseButtons, isProHSE, lmsModuleInfo, is992, profile?.accountId, additionalContent, discipline, disciplineColors, setCustomPullTime, isVotingDisabled, votesContent, coverContent, isLmsModerationType, setLongreadCounts, voteBlock])

    // @ts-ignore
    const visibleTextColor = tinycolor.mostReadable(calculatedColor, [Colors.geoWhite100, Colors.galBlack100]).toHexString();

    if (isAnimatedBook && !isServer) {
        return (
            <ModerationContext.Provider value={{
                project,
                toolsComponent: presentationEditBlock,
                voteBlock,
            }}>
                <MetaTags
                    title={computedProject?.title}
                    // description={metaTags}
                    images={computedProject?.titleImages}
                />
                <ChildrensBookView project={project} />
            </ModerationContext.Provider>
        )
    }

    return (
        <CommonProjectContainer>
            <BodyOverflowStyle />
            <ThemeProvider theme={theme as any}>
                {/* {chaptersPager} */}
                {/*@ts-ignore*/}
                {presentationEditor}
                {presentationVoteBlock}
                <MetaTags
                    title={computedProject?.title}
                    // description={metaTags}
                    images={computedProject?.titleImages}
                />
                <CustomBgWrapper backgroundColor={calculatedColor}>
                    <PageViewportLayout
                        vtype={vtype}
                        skipReducedVersion={skipReducedVersion}
                        offsetTop={isLMS ? 14 : ['t-shape', 'fixed-ratio-large', 'fixed-ratio-small', 'free-type'].includes(vtype)
                            ? 0 : (is992 ? 10 : isMac13 ? 12 : 14)
                        } style={{ position: 'relative' }}>
                        {shouldDisplayPresentationEditor ? presentationLongreadBox : (
                            <ProjectDisplayLayout
                                project={project}
                                canViewStatus={canViewStatus}
                                isLoading={isProjectLoading}
                                bgColor={calculatedColor}
                                blockedState={blockedState}
                                //@ts-ignore
                                image={project?.isAdaptiveCard ? <WarholCardCoverBg><WarholCardCover project={project} /></WarholCardCoverBg> : (isCollectionVote && !images?.length) ?
                                    <VoteCollectionCover project={project} /> :
                                    // @ts-ignore
                                    <PSImage competitionInfo={project.competitions} project={computedProject}
                                        onClick={zoom.show} />}
                                contextName={<ProjectContextName />}
                                title={(
                                    <Title maxTitleWidth={maxTitleWidth} isAgeytomesh={isAgeyTomesh}
                                        isProjectEdit={!isBooks && !isOnlines} visibleTextColor={visibleTextColor}>
                                        {computedProject.title}
                                    </Title>
                                )}
                                author={<PSAuthor theme={theme} project={project} />}
                                isOwner={isOwner}
                                shouldHideTags={shouldHideTags}
                                purchase={<ProjectPurchase project={project} isModer={shouldVisiblePurchase} />}
                                editorTags={<TagsEditor project={project} setProject={setProject}
                                    projectSource={projectSource}
                                    setProjectSource={setProjectSource} />}
                                point={<ProjectPoint project={project} />}
                                mobileOffset={mobileOffset}
                                tags={Tags}
                                team={<PSTeam project={computedProject} raw={project} />}
                                bottom={isBookBuyProccessing ? undefined :
                                    <PSBottom queueButton={QueueButtonsComponent} reloadProject={onUpdate}
                                        pollInfo={pollInfo} isEmptyProjectTags={false} project={project}
                                        onShouldReload={setProject} isProjectPage={!isOnlines}
                                        isPresentationTooltip={shouldDisplayPresentationEditor}
                                        isPresentation={shouldDisplayPresentationEditor}
                                        iSBookMainPage={project?.isBook} isOwner={isOwner} channel={channel!}
                                        onBlockedStateChange={handleBlockedStateChange} />}
                                //@ts-ignore
                                queue={((project?.book?.paymentType === PaymentStatus.PayBook || project?.paymentType === PaymentStatus.PayBook) && showQueue) && (project?.isBook || project?.book) &&
                                    <QueueNew
                                        currentQueuePoint={{ number: 1, type: QueueCircleType.current }}
                                        mode={QueueMode.view}
                                        rate={QueueRate.high}
                                        isBook
                                        cardsLength={additionalItems?.length || 0}
                                        userQueuePoints={[]} />}
                                subscribeInfo={<SubscribeInfo project={project} />}
                                roomLaunchBlock={<RoomLaunchBlockView
                                    selectedTags={[...(project?.tags || []), ...((project as any)?.requiredTags || [])].map(tag => tag.tagId)}
                                    projectId={project?.projectId}
                                />}
                                //@ts-ignore
                                longread={project?.isBook ? <PSChapters isLoading={isProjectLoading} project={project}
                                    disabled={isBookProjectPreview} /> :
                                    <PSLongread setPollTime={setCustomPullTime} disableVoting={isVotingDisabled}
                                        project={project} setMetaTags={setMetaTags}
                                        // @ts-ignore
                                        votesContent={votesContent} /*onZoom={zoom.show}*/
                                        protectInfoComponent={<PsProtectInfo
                                            limitContentCount={project?.limitContentCount}
                                            bookPaymentData={bookPaymentData}
                                            QueueButtonsComponent={QueueButtonsComponentBottom}
                                            project={project}
                                            longreadCount={longreadCountData?.count || 0}

                                        />}
                                        courseButtons={courseButtons}
                                        limitContentCount={project?.limitContentCount}
                                        pagingLimit={isLMS ? 0 : 12}
                                        onViewCurrentSlideScroll={project.isBook ? undefined : setLongreadCounts} />}
                                moreTitle={<PSMoreTitle project={project} />}
                                likesSticker={<StickyActionBar setMobileOffset={setMobileOffset} project={project}
                                    isModer={isModer} />}
                                statusVisible={statusVisible}
                                gameInfo={(isCollectionVote && !isPreview &&
                                    <ProjectGameInfo pollInfo={pollInfo} customPollTime={customPollTime}
                                        offsetTop={mobileOffset} bgColor={calculatedColor}
                                        isOwner={isOwner} projectId={project?.projectId} />) || undefined}
                                isCollectionVote={isCollectionVote}
                                inPartExam={<InPartExam project={project}
                                    competitionsExamCompleted={competitionsExamCompleted} />}
                                inPartCompetition={(
                                    <InPartCompetition
                                        competitionsParticipant={competitionsParticipant}
                                        competitionsWinner={competitionsWinner}
                                        competitionFynalist={competitionFynalist}
                                    />
                                )}
                                studentProject={
                                    <StudentProjectBlock project={project} />
                                }
                                // placeElement={<PlaceIconComponent competitionsWinner={competitionsWinner}/>}
                                // у организаций будет отдельная плашка модерации
                                dialog={currentTeam ? <OrganizationApprovalDialog project={project} /> :
                                    <ApprovalDialog project={project} reloadProject={onUpdate} onBlockedStateChange={handleBlockedStateChange} />}
                                bookBuyProcessingComponent={isBookBuyProccessing ?
                                    <BookBuyProcessingComponent bookPaymentData={bookPaymentData} /> : undefined}
                                protectStatus={<>
                                    <ProtectStatus project={project} visible={!!shouldVisibleProtectedStatus} />
                                </>}
                                bookmarkButtonMobile={<BookmarkButtonProjectPage entityId={project.projectId}
                                    entityType='project' />}
                            />
                        )}
                        {isLoadingCard ? (
                            <FlexBox
                                gx={isMobile ? 0 : 24}
                                gy={isMobile ? 24 : 0}
                                directionMobile="column"
                                justify="center"
                                align="center"
                                style={{ margin: "24px 0" }}
                            >
                                <Skeleton width={200} height={160} />
                                <Skeleton width={200} height={160} />
                                <Skeleton width={200} height={160} />
                                <Skeleton width={200} height={160} />
                            </FlexBox>
                        ) : (
                            //хардкод. Убрать isBook ,когда попросит нурс
                            collectionReprod?.length > 0 && !!project?.isBook && (
                                <BookCardsWithPay cards={collectionReprod} />
                            )
                        )}
                        <PSShop project={project} />
                        {!onlyContent && (
                            <PSBottomActions
                                tagsCount={projectTags?.length}
                                tags={Tags}
                                isLoading={isProjectLoading}
                                isEmptyProjectTags={isEmptyProjectTags}
                                theme={theme}
                                project={project}
                                titleVisible={!isPreview}
                                approveDialog={coverContent && project?.status !== 11 ? <ApprovalDialog project={project} isBottomMenu
                                    wide={shouldDisplayPresentationEditor && !is743} /> : null}
                            />
                        )}
                        {showChaptersNavigation &&
                            <ChaptersNavigation currentChapter={project} position={Position.bottom} />}
                        {projectTags.length > 0 && !isLMS && !onlyContent &&
                            <PsOtherProjects setIsEmptyProjectTags={setIsEmptyProjectTags} project={project} />}
                    </PageViewportLayout>
                </CustomBgWrapper>
                <ReactTooltip {...(isDafes || onWhiteBg ? tooptipStylesWhite : getTooltipStyles(theme as any))} />
                {!isLMS && <ScrollUpZone isPresentation={coverContent?.isPresentation} />}
                {project?.isBook || isLMS ? undefined :
                    <LongreadCountViewer isCollectionVote={isCollectionVote} data={longreadCountData} />}
                {isCollectionVote && !isPreview && <div id="game-info-portal" />}
                {isLMS && <div id="theme-nav-portal" />}
            </ThemeProvider>
        </CommonProjectContainer>
    );
};

export default memo(ProjectContent);
